import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Dashboard, DashboardCreate, DashboardFilter } from '../data/dashboard';

export function createDashboardService(client: AxiosInstance) {
  return createCrudService<Dashboard, DashboardCreate, DashboardFilter>(
    client,
    '/reporting/Dashboard',
    'id',
  );
}

export type DashboardService = CrudService<Dashboard, DashboardCreate, DashboardFilter>;
